import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMap } from '@widgets/Map'

export const MapControls = () => {
  const { mapApi, isReady } = useMap()
  const [isCogVisible, setIsCogVisible] = useState(false)
  const [isImageryVisible, setIsImageryVisible] = useState(false)

  const { t } = useTranslation()

  const handleToggleCog = () => {
    if (!isReady || !mapApi || !mapApi.setCogVisible) {
      console.warn('COG-слой недоступен или карта ещё не готова')

      return
    }

    const next = !isCogVisible
    setIsCogVisible(next)
    mapApi.setCogVisible(next)
  }

  const handleToggleImagery = () => {
    if (!isReady || !mapApi || !mapApi.setImageryVisible) {
      console.warn('Imagery-слой недоступен или карта ещё не готова')

      return
    }

    const next = !isImageryVisible
    setIsImageryVisible(next)
    mapApi.setImageryVisible(next)
  }

  const buttonStyle = {
    padding: '10px 20px',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 'bold' as const,
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 20,
        right: 20,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      {/*{mapApi?.setCogVisible && (*/}
      {/*  <button*/}
      {/*    disabled={!isReady}*/}
      {/*    style={{*/}
      {/*      ...buttonStyle,*/}
      {/*      backgroundColor: isCogVisible ? '#1976d2' : '#607d8b',*/}
      {/*      cursor: isReady ? 'pointer' : 'not-allowed',*/}
      {/*    }}*/}
      {/*    onClick={handleToggleCog}*/}
      {/*  >*/}
      {/*    {isCogVisible ? 'Выключить COG' : 'Включить COG'}*/}
      {/*  </button>*/}
      {/*)}*/}

      {mapApi?.setImageryVisible && (
        <button
          disabled={!isReady}
          style={{
            ...buttonStyle,
            backgroundColor: isImageryVisible ? '#00796b' : '#455a64',
            cursor: isReady ? 'pointer' : 'not-allowed',
          }}
          onClick={handleToggleImagery}
        >
          {t('map.controls.switchMode')}
        </button>
      )}
    </div>
  )
}
